import Reveal from "./Reveal";
import { Container, Eyebrow } from "./Primitives";

const ORGS = [
  { title: "Established SMBs", body: "Growing teams that need leverage without hiring a full in-house AI function." },
  { title: "Clinics & practices", body: "Reduce administrative load around scheduling, intake and patient communication." },
  { title: "Law firms", body: "Streamline intake, document workflows and internal knowledge retrieval." },
  { title: "Nonprofits", body: "Stretch limited capacity across programs, donor relations and reporting." },
  { title: "Selected government", body: "Carefully scoped modernization of services and internal processes." },
];

export default function Organizations() {
  return (
    <section id="organizations" className="bg-canvas py-28 sm:py-36">
      <Container>
        <div className="grid gap-14 lg:grid-cols-[1fr_1.4fr] lg:gap-24">
          <Reveal>
            <Eyebrow>For Organizations</Eyebrow>
            <h2 className="mt-6 font-display text-4xl font-light leading-[1.04] tracking-[-0.04em] text-fg sm:text-5xl">
              A fractional AI department for organizations that run on trust.
            </h2>
          </Reveal>
          <ul className="divide-y divide-fg/[0.08] border-y border-fg/[0.08]">
            {ORGS.map((o, i) => (
              <Reveal as="li" key={o.title} delay={i * 70} className="fa-org grid gap-2 py-6 sm:grid-cols-[200px_1fr] sm:gap-8">
                <h3 className="text-[15px] font-medium text-fg">{o.title}</h3>
                <p className="text-[15px] leading-relaxed text-subtle">{o.body}</p>
              </Reveal>
            ))}
          </ul>
        </div>
      </Container>
    </section>
  );
}
